// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"dfb20c95","710":"1cd673f4"}[chunkId] + ".chunk.js";
};